import type { ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
}

/**
 * One labelled band of Home.
 *
 * Flat by design: the heading sits on the page background and the content runs
 * underneath it, rather than each section living in its own bordered panel. At
 * 375px the nested-card alternative spends most of the width on chrome.
 */
export function HomeSection({ title, children }: Props) {
  return (
    <section className="min-w-0">
      <h2 className="mb-2 text-xs font-medium uppercase tracking-wide text-muted">{title}</h2>
      {children}
    </section>
  );
}

/** The card grid shared by Starred, Shared and Frequently opened. */
export function HomeCardGrid({ children }: { children: ReactNode }) {
  return (
    <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">{children}</ul>
  );
}
